import React from 'react';

import { DeleteRuleConfirmationDialog } from './DeleteRuleConfirmationDialog';
import IconButton from 'material-ui/IconButton';
import { MdEdit as EditIcon } from 'react-icons/md';

const RenderRule = ({ items, onEdit, onDelete, disabled }) => {
  return (
    <div>
      {items.map((item, index) => {
        const unsaved = !item.id ? ' (unsaved)' : '';
        return (
          <div
            id="mobile_card"
            key={index}
            style={{
              paddingBottom: '10px',
              textTransform: 'capitalize',
              maxWidth: '500px',
              margin: 'auto',
            }}
          >
            <DeleteRuleConfirmationDialog
              handleConfirmation={(confirmed) => {
                if (confirmed) {
                  onDelete(index);
                }
              }}
              disabled={disabled}
            />
            <EditButton disabled={disabled} onEdit={onEdit} index={index} />

            <div className="row">
              <h4 style={{ float: 'left' }}>
                {item.name}
                {unsaved}
              </h4>
            </div>

            <div className="row">
              <p style={{ float: 'left', marginTop: '5px' }}>
                <b>Target:</b> {item.target}
              </p>
            </div>

            <div className="row">
              <p style={{ float: 'left', marginTop: '1px' }}>
                <b> Rule Conditions:</b> {item.humanized_rule}
              </p>
            </div>

            <div className="row">
              <h5 style={{ float: 'left', marginTop: '5px' }}>Assigned to:</h5>
            </div>
            <div className="row" style={{ marginTop: '4px' }}>
              <ListOfProperties properties={item.properties} />
              <ListOfPropertiesShortened properties={item.properties} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

const EditButton = ({ disabled, onEdit, index }) => {
  if (disabled || !onEdit) return null;

  return (
    <IconButton
      style={{ float: 'right', padding: '0px', marginRight: '25px', backgroundColor: '#fff' }}
      onClick={() => onEdit(index)}
    >
      <EditIcon size={24} style={{ padding: '0px' }} />
    </IconButton>
  );
};

const ListOfProperties = ({ properties }) => {
  if (!properties) return null;
  if (properties.length > 5) return null;

  const names = properties.map((property) => property.label);
  return <p style={{ textAlign: 'left' }}>{names.join(', ')}</p>;
};

const ListOfPropertiesShortened = ({ properties }) => {
  if (!properties) return null;
  if (properties.length <= 5) return null;

  const names = properties.map((property) => property.label);
  return (
    <p style={{ textAlign: 'left' }}>
      {names[0]}, {names[1]} + {properties.length} others
    </p>
  );
};
export default RenderRule;
